// extracted by mini-css-extract-plugin
export var productImage = "_ps-1";
export var viewLink = "_ps-2";
export var wishlistItem = "_ps-0";